export async function fetchConfigurationByAudiCode({ code, country, language, webApiBaseUrl, }) {
    const url = `${webApiBaseUrl}/casa/v1/${country.toLowerCase()}/${language.toLowerCase()}/getConfigurations?vehicleCodes=${code}`;
    const response = await fetch(url);
    if (!response.ok) {
        console.error(`Failed to fetch configuration for audi code: ${code}`);
        return null;
    }
    const data = await response.json();
    return Array.isArray(data) ? data[0] || null : null;
}
//# sourceMappingURL=casa.js.map